"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isComplete = exports.isChecked = void 0;

var isComplete = function isRankInputComplete(isValid, complete) {
  return isValid || complete;
};

exports.isComplete = isComplete;

var isChecked = function isRankInputChecked(storedValue, option) {
  return storedValue.indexOf(option) > -1;
};

exports.isChecked = isChecked;